module.exports = __webpack_public_path__ + "static/media/tablet-alt.8da50e99.svg";